// https://www.dbos.dev/blog

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { FeaturedPosts, LatestArticles } from '@components/cms/BlogIndex';

export function BlogPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '.clamp-text {\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Adjust to the approximate number of lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}',
        }}
      />
      <header className="blog_header">
        <h1 className="blog_header-title">Blog</h1>
        <p className="blog_header-tagline">{'The latest on durable execution & company updates'}</p>
      </header>
      <FeaturedPosts />
      <div className="card-insight-latest-wrapper">
        <h2 className="text-heading-h2">Latest articles</h2>
        <LatestArticles />
      </div>
    </SiteLayout>
  );
}
